import { render, staticRenderFns } from "./RolesMenu.vue?vue&type=template&id=1f46ace0&scoped=true&"
import script from "./RolesMenu.vue?vue&type=script&lang=js&"
export * from "./RolesMenu.vue?vue&type=script&lang=js&"
import style0 from "./RolesMenu.vue?vue&type=style&index=0&id=1f46ace0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46ace0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f46ace0')) {
      api.createRecord('1f46ace0', component.options)
    } else {
      api.reload('1f46ace0', component.options)
    }
    module.hot.accept("./RolesMenu.vue?vue&type=template&id=1f46ace0&scoped=true&", function () {
      api.rerender('1f46ace0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/RolesMenu.vue"
export default component.exports